module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0097.jpg?v=b756b109";